export function clearToken(): void {
    localStorage.removeItem('id_token');
}

export function getToken(): string {
    try {
        const idToken = localStorage.getItem('id_token') || '';
        return idToken;
    } catch (err) {
        clearToken();
        return '';
    }
}
export function setToken(token: string): void {
    localStorage.setItem('id_token', token);
}
